import { Controller } from "@hotwired/stimulus"
import { destroy } from "@rails/request.js"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.element.addEventListener("turbo:submit-end", (event) => {
      if (event.detail.success && this.hasInputTarget) {
        this.inputTarget.value = ""
      }
    })
  }

  // Handles pill:remove events bubbled from Ui::PillComponent chips
  async removeTag(event) {
    const pill = event.detail.pill
    const deleteUrl = pill?.dataset?.deleteUrl
    if (!deleteUrl) return

    // Turbo Stream response is automatically processed by @rails/request.js
    await destroy(deleteUrl, { responseKind: "turbo-stream" })
  }
}
